import moment from 'moment';
import {
  PATH_STRING_SEPARATOR
} from '../common/config.js';
import {
  IncidentsModalController
} from './add-to-incidents/incidents-modal.component';

export function FactTableRowComponent($compile) {
  return {
    restrict: 'A',
    scope: {
      filter: '=',
      fact: '=',
      openImage: '=',
      listType: '=',
      select: '=',
      ready: '=',
    },
    controller: function(
      $scope,
      $element,
      $timeout,
      RouterService,
      AlertModalService,
      $modal,
      $http,
      FaceService,
      SpecialModalService,
    ) {
      $scope.router = RouterService;
      $scope.AlertModalService = AlertModalService;
      $scope.sep = PATH_STRING_SEPARATOR;

      $scope.toUserNearestScreenshot = () => {
        $scope.router.needToShowFact = {
          needShowScreenshot: false,
          fact: $scope.fact,
          date: $scope.fact.local_time
        };
        $scope.router.toUserNearestScreenshot();
        $scope.router.filterChanged();
      };

      $scope.addToIncidents = () => {
        // console.log($scope.fact);
        $scope.modalInstance = $modal
          .open({
            template: require('./add-to-incidents/incidents-modal.component.html'),
            controller: IncidentsModalController,
            scope: $scope,
          })
          .result.then(() => {
            // console.log(res);
          }, err => {
            $scope.AlertModalService.open(`${err.status} ${err.status ? err.statusText :''}`, err.data);
          });
      };

      $scope.toNeighbourEvents = () => {
        $scope.router.needToShowFact = {
          fact: $scope.fact,
          date: $scope.fact.local_time
        };
        $scope.router.toNeighbourEvents();
        $scope.router.filterChanged();
      };

      $scope.findSimular = () => {
        $scope.router.findSimular($scope.fact.id);
      };

      $scope.deleteEvent = () => {
        SpecialModalService.deleteEvent($scope.fact.id, function onSuccess() {
          $scope.$emit('reload');
        });
      };

      $scope.printerExport = () => {
        window.open('/analytics/printer/export/' + $scope.fact.id, '_blank');
      };

      $scope.openFace = (fact, index) => {
        FaceService.openFace(fact, index);
      };

      $element.ready(() => {
        $scope.scrollElement = $element.parent();
      });

      $scope.isReady = () => {
        if ($scope.fact.needToShowTD && $scope.ready)
          $scope.fact.showedTD = true;
        return $scope.ready || $scope.fact.showedTD;
      };
    },

    link: function(scope, element, attrs) {
      if (!scope.fact) return '';
      const noAddMenu =
        scope.filter.toExcel && scope.filter.toExcel.convertToExel;
      scope.viewMode = scope.$parent.viewMode;
      const colQty = scope.viewMode.columns.length;

      scope.table = element.closest('sc-facts-table');
      scope.tableBody = scope.table.find('tbody')[0];

      const widget = scope.viewMode.columns
        .map((colView, c) => {
          const thSelector = scope.table.find('.fact-table th:visible');
          const th = thSelector[c];
          const lastCol = !scope.router.isFilterEditModal && c === colQty - 1;

          let findSimularElem = '';
          if (!noAddMenu && scope.fact.text_data && lastCol) {
            findSimularElem = `
          <li >
            <a ng-click="findSimular()"> ${gettext(
              'Найти похожие документы'
            )}</a>
          </li>`;
          }

          const event_type = scope.fact['agent_eventtype.id'];

          if (!noAddMenu && event_type == 11 && lastCol) {
            findSimularElem += `
          <li >
            <a ng-click="printerExport()" target="_new"> ${gettext(
              'Экспорт в PDF'
            )}</a>
          </li>`;
          }

          let lastMenuElem = '';
          if (!noAddMenu && lastCol) {
            lastMenuElem = `<span class="dropdown to-screenshot">
          <i data-toggle="dropdown"
            ng-if="true"
            class="icon-wrench dropdown-toggle"
          ></i>
          <ul class="dropdown-menu pull-right" sc-ul>
            <li >
              <a ng-click="toUserNearestScreenshot()">${gettext(
                'К ближайшему снимку с экрана'
              )}</a>
            </li>
            <li >
              <a ng-click="toNeighbourEvents()">${gettext('События рядом')}</a>
            </li>
            ${findSimularElem}
            <li>
              <a ng-click="addToIncidents()">${gettext('Добавить событие в инцидент')}</a>
            </li>
            <li >
              <a ng-click="deleteEvent()">${gettext('Удалить событие')}</a>
            </li>
          </ul>
        </span>`;
          }

          return `<td ng-if='fact.needToShowTD' ng-show='isReady()' class="${
            colView['cssClass'] ? colView['cssClass'] : ''
          } rc-${c}"> ${colView.parse(
            scope.fact,
            'short'
          )}${lastMenuElem}</td>`;
        })
        .join('', '');
      try {
        element.append(widget);
      } catch (e) {
        console.log(gettext('Ошибка при формировании элемента:'));
        console.error(widget);
        console.error(e);
      }
      $compile(element.contents())(scope);

      scope.scrollElement.on('scroll', function(e) {
        const elHeight = element.height() || 33;
        const offsetTop = element.offset().top;
        const tableHeight = scope.tableBody.clientHeight;
        scope.fact.factHeight = elHeight < 600 ? elHeight : 600;

        scope.fact.needToShowTD = scope.fact.selected || offsetTop + elHeight + tableHeight > 0 && offsetTop < tableHeight + tableHeight;
        if (!scope.fact.needToShowTD) scope.fact.showedTD = false;

      });
    }
  };
}



// WEBPACK FOOTER //
// ./src/facts/fact-table-row.component.js